/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_ES = {
  "  Checked by (signature)": "  Verificado por (firma)",
  "! 3 of 4 types required:": "! Se requieren 3 de 4 tipos:",
  "! Min. 14 characters": "! Mín. 14 caracteres",
  "! No name/username parts": "! Sin partes del nombre/nombre de usuario",
  "! No spaces": "! Sin espacios",
  "/ occasion": "/ ocasião",
  "A new password should be different than the current one": "Una nueva contraseña debe ser diferente a la actual",
  "ACCEPTED": "ACEPTADO",
  "Active flights": "Voos ativos",
  "Add deicing/anti-icing": "Añadir deicing/anti-icing",
  "Add description": "Añadir descripción",
  "Add description if there is a irregularity!": "¡Agregue la descripción si hay una irregularidad!",
  "Add line": "Añadir línea",
  "Add location where item was found": "Añadir el lugar donde se encontró el artículo",
  "Add note": "Añadir la nota...",
  "add occasion": "añadir ocasión",
  "Add other location": "Añadir otra ubicación",
  "Add row": "Añadir fila",
  "Add storage location": "Añadir lugar de almacenamiento",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Agrega tu correo de recuperación para que podamos enviarte un código si olvidas tu contraseña.",
  "additional services": "Servicios adicionales",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Após clicar em 'CONFIRMAR', o MVT de correção será enviado. Pode ser reenviado se houver uma alteração em ALDT ou/ e AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Após clicar em 'CONFIRMAR', o MVT será enviado. Pode ser reenviado se houver uma alteração em ALDT ou/ e AIBT.",
  "Agent's name:": "Nombre del agente:",
  "Agent's signature:": "Firma del agente:",
  "Aircraft Damage": "Daños en la aeronave",
  "Aircraft type": "Tipo de aeronave",
  "Airline": "Línea aérea",
  "All": "Todos",
  "ALL": "TODOS",
  "All Airlines with Stocks": "Todas las aerolíneas con stocks",
  "An error occurred while trying to verify your email address.": "Ocorreu um erro ao tentar verificar seu endereço de e-mail.",
  "and": " y ",
  "and/or": "y/o",
  "Anti-icing": "Anti-icing",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Qualquer e-mail com @aviapartner.aero ou @aviavip.com não é aceito!",
  "APPLY": "APLICA",
  "approved": "aprobado",
  "Apr": "Abr",
  "Archived": "Archivado",
  "Are you sure you want to change your password?": "¿Está seguro de que desea cambiar su contraseña?",
  "Are you sure you want to exit the current process?": "¿Está seguro de que desea salir del proceso actual?",
  "Are you sure you want to remove photo?": "¿Estás seguro de que quieres eliminar la foto?",
  "Are you sure you want to sign out?": "¿Estás seguro de que quieres cerrar la sesión?",
  "area": "zona",
  "Arrival MVT has been sent": "MVT ha sido enviado",
  "Arrival MVT not sent yet": "MVT no enviado",
  "Arrival MVT sending": "Enviando MVT llegada",
  "Arrival MVT sent successfully": "MVT de llegada enviada con éxito",
  "Attach photo": "Adjuntar foto",
  "Attachment": "Adjunto",
  "Aug": "Ago",
  "Available": "Disponible",
  "Belt": "Cinto",
  "Body": "Cuerpo",
  "Briefly describe where the item will be stored for picking up.": "Describa brevemente dónde se almacenará el artículo para su recogida.",
  "Call {{firstName}} {{lastName}}": "Llamar a {{firstName}} {{lastName}}",
  "Call sign": "Distintivo de llamada",
  "Cancel": "Cancelar",
  "CANCEL": "CANCELAR",
  "Cannot be after": "No puede ser después ",
  "Cannot be before": "No puede ser antes ",
  "Cannot create MVT message: missing flight information": "No se puede crear el mensaje MVT: falta información del vuelo",
  "Cannot send Arrival MVT": "No se puede enviar MVT llegada. Las direcciones (SITA o/y email) no se han configurado en Sunrise.",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Não é possível enviar o MVT de chegada. Os endereços (SITA e/ou e-mail) para este voo não estão configurados no Sunrise.",
  "Cannot send MVT ETD": "No se puede enviar MVT ETD. Las direcciones (SITA o/y email) no se han configurado en Sunrise.",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Não é possível enviar o MVT ETD. Os endereços (SITA e/ou e-mail) para este voo não estão configurados no Sunrise.",
  "Cannot set a future time.": "No se puede fijar una hora futura.",
  "Change": "Cambiar",
  "Change password": "Cambiar contraseña",
  "Change password?": "¿Cambiar la contraseña?",
  "Change your password:": "Cambiar la contraseña:",
  "Checked by (signature)": "Verificado por (assinatura)",
  "Checks on easily visible parts of the aircraft from the ground": "Verificaciones a partes fácilmente visibles de la aeronave desde tierra. Sin daños obvios o anomalias:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Verificações em partes facilmente visíveis da aeronave a partir do solo. Nenhum dano ou anomalia óbvia para:",
  "Chocks": "Choques",
  "Chute": "Chute",
  "CLEAR": "Claro",
  "Client's signature:": "Firma del cliente:",
  "Clocked Time": "Hora registrada",
  "Close": "Cerrar",
  "CLOSE": "CERRAR",
  "Close all my sessions on all devices": "Fechar todas as minhas sessões em todos os dispositivos",
  "Close registration": "Cerrar el registro",
  "CLOSE REGISTRATION": "FECHAR REGISTO",
  "close the flight": "cerrar el vuelo",
  "Closed": "Fechado",
  "Closing this window will discard all your recent changes.": "Cerrar esta ventana descartará todos sus cambios recientes.",
  "Clouds": "Nubes",
  "Comment": "Comentario",
  "Comment...": "Comentário...",
  "Comments": "Comentarios",
  "Completed": "Completado",
  "Conditional services": "Servicios condicionales",
  "Cones": "Conos",
  "CONFIRM": "CONFIRMAR",
  "Confirm": "Confirmar",
  "Confirm new password": "Confirmar la nueva contraseña",
  "Confirm remove?": "¿Confirmar la eliminación?",
  "CONFIRMED": "CONFIRMADO",
  "Contact your administrator to request access": "Contacta a tu administrador para solicitar acceso",
  "Could not save data, please try again later": "No se han podido guardar los datos, por favor, inténtelo más tarde",
  "Crew signature": "FIRMA CREW",
  "Current password": "Contraseña actual",
  "Damage": "Daño",
  "Date range": "Rango de fechas",
  "Date should not be before start date": "La fecha no debe ser anterior a la fecha de inicio",
  "Day": "Día",
  "Dec": "Dez",
  "DECLINED": "DECLINADO",
  "Default station": "Estación predeterminada",
  "Deicing": "Descongelamento",
  "Deicing Service Registration": "Registro del servicio de deshielo",
  "Delete Photo": "Eliminar foto",
  "DENIED": "DENEGADO",
  "Describe location": "Describa la ubicación",
  "Dest.": "Dest.",
  "Destination": "Destino",
  "Did you forget something?": "¿Olvidaste algo?",
  "Don't use phone while driving!": "Prohibido usar el móvil mientras conduzcas!",
  "Dummy Type": "Tipo de maniquí",
  "Edit Comment": "Editar comentario",
  "Emergency": "Emergencia",
  "Emergency contacts are not set up": "Los contactos de emergencia no están configurados.",
  "employees": "empleados",
  "End": "Fin",
  "End of anti-icing": "Fin de la anti-congelación",
  "End Time": "Fin de los tiempos",
  "End time should not be before start time": "La hora de finalización no debe ser anterior a la hora de inicio",
  "Entrance": "Entrada",
  "Error loading clocked times": "Error al cargar las horas registradas",
  "Error. The email doesn't meet standard formatting.": "Erro. O e-mail não atende à formatação padrão.",
  "exceeds the allowed limit for this flight": " excede el límite permitido para este vuelo.",
  "Executor's name:": "Nombre del albacea:",
  "Executor's signature:": "Firma del albacea:",
  "extra service": "Servicio extra",
  "Extra services": "Servicios extras",
  "Extra shift request": "Solicitud de turno extra",
  "Extra Shift Request": "Solicitud de turno extra",
  "Extra shift request confirmed": "Solicitud de turno extra confirmada",
  "failed": "falló",
  "Feb": "Feb",
  "Filter": "Filtro",
  "Filter group": "Grupo de filtrado",
  "Filter group has not been updated": "El grupo de filtros no ha sido actualizado",
  "filter group not found": "grupo de filtrado no encontrado",
  "finalization": "finalización",
  "Find the account recovery section and click \"Resend verification email\".": "Encontre a seção de recuperação de conta e clique em \"Reenviar e-mail de verificação\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError: No se puede escribir un documento porque supera el tamaño máximo permitido",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: Um documento não pode ser gravado porque excede o tamanho máximo permitido",
  "Flight": "Vuelo",
  "Flight details": "Detalles del vuelo",
  "Flight information registration": "Registro de información de vuelo",
  "Flight not found": "Vuelo no encontrado",
  "Flight number/registration": "Número de vuelo/registro",
  "Flight registration is closed": "El registro de vuelos está cerrado.",
  "Flight reopened": "Vuelo reabierto",
  "Flight type": "Tipo de vuelo",
  "Flights": "Vuelos",
  "Fluid name": "Nome do fluido",
  "Fluid name:": "Nombre del fluido:",
  "Fluid type": "Tipo de fluido",
  "Forgot your password?": "Esqueceu-se da sua palavra-passe?",
  "Forms": "Formularios",
  "from": "de",
  "From": "De",
  "Full (Wings, stabilizer &, fuselage)": "Completo (Alas, estabilizador y fuselaje)",
  "Future time is not allowed": "El tiempo futuro no está permitido",
  "Gate": "Puerta",
  "General info": "Información general",
  "Go to flights": "Ir a vuelos",
  "Go to login": "Ir a iniciar sesión",
  "Go to My Profile in your Sunrise account.": "Vá para Meu Perfil na sua conta Sunrise.",
  "Go to Unread R&S": "Ir a R&S sin leer",
  "Helpdesk": "Servicio de asistencia técnica",
  "Hold Inspection on Arrival": "Inspección de bodega llegada",
  "Hold Inspection on Departure": "Inspección de bodega partida",
  "hr": "hr",
  "Humidity": "Humedad",
  "If damage is found, mark it on the sketch": "Si se encuentran daños, márquelo en el boceto.",
  "If the problem continues, go to My Profile to resend a new verification link.": "Se o problema continuar, vá para Meu Perfil para reenviar um novo link de verificação.",
  "In order to close this flight you need to provide": "Para cerrar este vuelo es necesario proporcionar los datos obligatorios.",
  "In order to close this flight you need to provide mandatory details.": "Para fechar este voo, você precisa fornecer detalhes obrigatórios.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "Para abrir el 'Calendario', leer y procesar los mensajes recientes de Read & Sign.",
  "In order to send Arrival MVT you need to provide mandatory details": "Para enviar el MVT llegada es necesario incluir los datos requeridos.",
  "Include nearby area": "Incluir la zona cercana",
  "Included nearby area": "Incluye la zona cercana",
  "Incorrect code": "Código incorrecto",
  "Input a brief description here": "Introduzca una breve descripción aquí",
  "Inspected by": "Inspeccionado por",
  "Inspection agent's signature": "Assinatura do agente de inspeção",
  "Inspection agent's signature:": "Firma del agente de inspección:",
  "Inspections": "Inspecciones",
  "Instructions": "Instrucciones",
  "Internal communication": "Comunicación interna",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Ya existe un valor ALDT/AIBT no válido o un MVT de llegada con dichos valores ALDT y AIBT.",
  "is logged in": "está conectado",
  "Is Partial": "Es parcial",
  "is signed in": "se firma en",
  "It's safe and encrypted - only used for password resets.": "Está seguro y encriptado — solo se usa para restablecer la contraseña.",
  "Jan": "Jan",
  "Job vacancy": "Oferta de empleo",
  "Jul": "Jul",
  "Jun": "Jun",
  "KEY PEOPLE": "PERSONAS CLAVE",
  "Language": "Idioma",
  "Leave a comment about this timestamp and connected action.": "Deje un comentario sobre esta marca de tiempo y la acción conectada.",
  "Left Engine": "Motor izquierdo",
  "Left Tail Wing": "Ala de cola izquierda",
  "Left Wing": "Ala izquierda",
  "Load Verification Cross-Check Form": "Formulario Cross-Check Verificación de Carga",
  "Local (Under Wing / Local area contamination)": "Local (Sob a Asa / Contaminação da área local)",
  "Local Bags": "Bolsas Locales",
  "Locked application": "Aplicación bloqueada",
  "Log in": "Entrar en el sistema",
  "Log out": "Cerrar la sesión",
  "Lost item": "Objeto perdido",
  "lowercase": "minúsculas",
  "Mar": "Mar",
  "Mark location": "Ubicación de la marca",
  "May": "Mai",
  "Message archived": "Mensaje archivado",
  "Message state": "Estado del mensaje",
  "Message type": "TIPO DE MENSAJE",
  "Message unarchived": "Mensaje no archivado",
  "Messages": "Mensajes",
  "messages yet": "mensajes todavía",
  "min": "min",
  "Mix": "Mezcla",
  "Month": "Mes",
  "MVT History": "Histórico MVT",
  "My profile": "Mi perfil",
  "Name Surname": "Nombre Apellidos",
  "Neck": "Cuello",
  "New password": "Nueva contraseña",
  "New password cannot be equal to current": "La nueva contraseña no puede ser igual a la actual.",
  "New password does not meet security requirements": "La nueva contraseña no cumple con los requisitos de seguridad",
  "next": "siguiente",
  "Next 5 days": "Próximos 5 días",
  "No": "No",
  "No active flights yet": "No hay vuelos activos aún",
  "No clocked times available": "No hay horas registradas disponibles",
  "No content yet...": "Aún no hay contenido...",
  "No flight details information": "No hay información sobre los detalles del vuelo",
  "No instructions found": "No se encontraron instrucciones",
  "No internet connection": "No hay conexión a Internet",
  "No key people assigned.": "No hay personas clave asignadas.",
  "No messages yet": "Todavía no hay mensajes",
  "No photo available": "No hay fotos disponibles",
  "No photos here yet": "No hay fotos",
  "No registration": "No hay registro",
  "No services available": "No hay servicios disponibles",
  "No time logging found": "No se encontró registro de tiempo",
  "No timestamps configured for this flight type": "No hay marcas de tiempo configuradas para este tipo de vuelo",
  "No types here yet": "No hay tipos aquí todavía",
  "no user data": "sin datos del usuario",
  "None": "Ninguno",
  "Nose": "Nariz",
  "Not completed": "No completado",
  "Note": "Nota:",
  "Nov": "Nov",
  "NOW": "AHORA",
  "Number of unread R&S:": "Número de R&S sin leer:",
  "numbers": "números",
  "occasion": "ocasión",
  "Occasion": "Ocasión",
  "Oct": "Out",
  "Oops! It looks like your verification email didn't go through.": "Ops! Parece que o seu e-mail de verificação não foi enviado.",
  "Open": "Aberto",
  "Open a flight to add it to your active flights list.": "Abra un vuelo para agregarlo a su lista de vuelos activos.",
  "Open file": "Abrir archivo",
  "Open flight {{name}}": "Abrir vuelo {{name}}",
  "Operation flight number": "Número de vuelo de operación",
  "Operator's name": "Nome do operador",
  "Operator's name:": "Nombre del operador:",
  "Operator's signature": "Assinatura do operador",
  "Operator's signature:": "Firma del operador:",
  "Optional": "Opcional",
  "or": "o",
  "Origin": "Origen",
  "Other flights": "Outros voos",
  "Outside Air Temperature": "Temperatura del aire exterior (C°)",
  "Outside Air Temperature (C°)": "Temperatura do ar externo (C°)",
  "Page not found": "Página no encontrada",
  "Parking": "Aparcamiento",
  "Partially (Wings & stabilizer only)": "Parcialmente (Solo alas y estabilizador)",
  "Password": "Contraseña",
  "Password must be at least 8 characters": "La contraseña debe tener al menos 8 caracteres y contener al menos 1 letra mayúscula y 1 minúscula, 1 símbolo, 1 dígito y sin espacios en blanco.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "La contraseña no es única. Su nueva contraseña no puede ser una de sus 5 últimas contraseñas utilizadas.",
  "Passwords do not match": "Las contraseñas no coinciden",
  "per occasion": "por ocasião",
  "Per pax": "Por passageiro",
  "per start": "por início",
  "percent": "porcentagem",
  "Photo registration": "Registro fotográfico",
  "Photo types required": "Tipos de fotos requeridas",
  "Photo types required:": "Tipos de fotos requeridas:",
  "Photos": "Fotos",
  "Pick if its a damaged part or lost item": "Elija si es una pieza dañada o un artículo perdido",
  "Pin on schema": "Pin en el esquema",
  "Please briefly describe where you found the item": "Describa brevemente dónde encontró el artículo. Especifique la sala o la línea y la fila si está disponible",
  "Please click here to proceed to flights list": "Haga clic aquí para pasar a la lista de vuelos",
  "Please make sure you attached photos of irregularities": "Asegúrese de adjuntar fotos de irregularidades",
  "Please pick on scheme": "Por favor, elija el esquema",
  "Please reach out to your administrator for assistance": "Comuníquese con su administrador para obtener ayuda.",
  "Please try sending it again later.": "Por favor, tente enviá-lo novamente mais tarde.",
  "Please try the link again.": "Por favor, tente o link novamente.",
  "Please, sign below": "Por favor, firme abajo",
  "Post-deicing/anti-icing check completed": "Verificación posterior a la descongelación/anti-congelación completada",
  "Precipitation": "Precipitación",
  "Pressure": "Presión",
  "Proceed to login": "Proceder al inicio de sesión",
  "Product name": "Nombre producto",
  "Product type": "Tipo producto",
  "Profile": "Perfil",
  "Profile data wasn't updated!": "Los datos del perfil no se actualizaron",
  "Psychosocial aid": "Ayuda psicosocial",
  "Quantity (liter)": "Cantidad (litros)",
  "Read": "Leer",
  "Read & Sign": "Leer y firmar",
  "Read & Sign to do:": "Leia e assine para fazer:",
  "Read&Sign": "Ler e assinar",
  "Receive Extra shift requests": "Recibir solicitudes de turno extra",
  "Receive job vacancies": "Recibir ofertas de empleo",
  recovery: {
    "error1": "<1>¡Ups!</1> Parece que su correo de verificación no se ha enviado.",
    "error2": "<1>Intente enviarlo de nuevo más tarde.</1>",
    "error3": "Pedimos disculpas por las molestias.",
    "inUse": "Este correo de recuperación ya está <1>en uso</1>.",
    "success": "El <1>correo de verificación</1> se ha enviado correctamente.",
    validation: {
      "blockedDomainNote": "No se acepta ningún correo con <1>@aviapartner.aero</1> o <3>@aviavip.com</3>.",
      "invalidFormat": "Error. El correo electrónico no cumple con el formato estándar."
    },
    "verified": "Su correo de recuperación ya está <1>verificado</1>."
  },
  "Recovery email": "Correo de recuperación",
  "Recovery email already verified!": "E-mail de recuperação já verificado!",
  "Recovery email verified!": "E-mail de recuperação verificado!",
  "Reg.": "Reg.",
  "Registration": "Matrícula",
  "Registration Closed": "Inscripción cerrada",
  "REGISTRATION CLOSED": "REGISTO FECHADO",
  "registration complete": "registro completo",
  "Remark": "Observação",
  "Remove": "Eliminar",
  "Remove {{name}} from active flights": "Eliminar {{name}} de vuelos activos",
  "Reopen": "Reabrir",
  "reopen flight": "reabrir el vuelo",
  "Report any irregularities found upon arrival": "Informar de cualquier irregularidad encontrada a la llegada",
  "Report any other irregularities": "Informar de cualquier otra irregularidad.",
  "Required": "Requerido",
  "required to close the flight": "Requerido para cerrar el vuelo",
  "Requirements of the password are not met.": "No se cumplen los requisitos de la contraseña.",
  "Resend verification email": "Reenviar correo de verificación",
  "Right Engine": "Motor derecho",
  "Right Tail Wing": "Ala de cola derecha",
  "Right Wing": "Ala de la derecha",
  "Runway": "Pista",
  "Safety Ramp Checklist": "Lista de verificación de seguridad de la rampa",
  "Safety Ramp Inspection": "Inspección de la rampa de seguridad",
  "SAVE": "Guardar",
  "save": "guardar",
  "Save service registrations problem": "Guardar el problema de las inscripciones al servicio",
  "Screening": "Triagem",
  "Search": "Buscar en",
  "Seat": "Asiento",
  "Seats": "Asientos",
  "Select type": "Seleccione el tipo",
  "SEND ARRIVAL MVT": "ENVIAR MVT LLEGADA",
  "SEND CORRECTION ARRIVAL MVT": "ENVIAR CORRECCIÓN MVT LLEGADA",
  "Send the Arrival MVT message to recipients:": "Enviar MVT llegada a destinatarios:",
  "SENT": "ENVIADO",
  "Sep": "Set",
  "Service info saved": "Información de servicio guardada",
  "Service registration": "Registro de servicios",
  "Service registration is closed": "El registro del servicio está cerrado.",
  "Service Type": "Tipo de servicio",
  "Set": "Establecer",
  "Set date": "Establecer fecha",
  "Set time": "Fijar la hora",
  "Set time: End of anti-icing": "Establecer hora: Fin de la anti-congelación",
  "Set to now": "Ajustar a ahora",
  "Short remark": "Breve comentario",
  "Show": "Mostrar",
  "Show Photo": "Mostrar foto",
  "Sign for understanding": "Signo de comprensión",
  "Sign form below to complete it": "Firme a continuación para completar el formulario:",
  "Sign in": "Acceder",
  "Sign out": "Desconexión",
  "Signed": "Firmado",
  "SKIP": "OMITIR",
  "Skip this step": "Omitir este paso",
  "Something went wrong": "Algo salió mal",
  "Something went wrong. Please try again later.": "Algo salió mal. Vuelve a intentarlo más tarde.",
  "Something wrong": "Algo va mal",
  "Sort.": "Ordenar",
  "Specify where did you found the item": "Especifique dónde encontró el artículo",
  "Start": "Hora",
  "Start anti-icing": "Comienzo anti-icing",
  "Start Time": "Hora de inicio",
  "Station": "Estación",
  "Stations": "Estaciones",
  "Stop anti-icing": "Fin anti-icing",
  "success": "éxito",
  "Sunrise": "Amanecer",
  "Sunset": "Atardecer",
  "Switch flight": "Cambiar vuelo",
  "symbols": "símbolos",
  "SYSTEM SETTINGS": "Configuración del sistema",
  "Tail": "Cola",
  "Take a photo": "Haz una foto",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Tome una fotografía de una acción terminada, esta marca de tiempo está dedicada a.",
  "Tap on area where damaged part is located": "Golpear la zona donde se encuentra la pieza dañada",
  "Task": "Tarea",
  "Tasks & Flights": "Tareas y vuelos",
  "Telex messages": "Mensajes de télex",
  "Temperature (C°)": "Temperatura (C°)",
  "The app has been updated": "La aplicación se ha actualizado",
  "The APPI code is required when resetting your Aviapartner": "El código APPI es necesario para restablecer la contraseña de su cuenta Aviapartner en Sunrise o a través del servicio de asistencia de Aviapartner. Siempre podrá encontrar su código APPI en su perfil en Sunrise.",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "O código APPI é necessário ao redefinir a senha da sua conta Aviapartner no Sunrise ou através do helpdesk Aviapartner. Você sempre pode encontrar seu código APPI em seu perfil no Sunrise.",
  "the correction MVT will be sent": "Después de hacer clic en 'CONFIRMAR', se enviará el MVT de corrección. Se puede volver a enviar si hay un cambio en ALDT o/y AIBT.",
  "The current password you entered is incorrect.": "La contraseña actual introducida es incorrecta.",
  "The current password you've entered is incorrect": "La contraseña que has introducido es incorrecta. Por favor, compruébala e inténtalo de nuevo.",
  "The elapsed time between": "El tiempo transcurrido entre ",
  "The end time must be later than the start time.": "La hora de finalización debe ser posterior a la hora de inicio.",
  "the MVT will be sent": "Después de hacer clic en 'CONFIRMAR', se enviará el MVT. Se puede volver a enviar si hay un cambio en ALDT o/y AIBT.",
  "The planning shown below might not be up-to-date": "Es posible que la planificación que se muestra a continuación no esté actualizada.",
  "The shift is already confirmed to": "El turno ya está confirmado para",
  "The username or password you've entered is incorrect": "El nombre de usuario o la contraseña que has introducido son incorrectos. Por favor, compruébalo e inténtalo de nuevo.",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "O nome de usuário ou a senha que você digitou está incorreto. Por favor, verifique novamente e tente novamente.",
  "The verification email has been sent successfully!": "O e-mail de verificação foi enviado com sucesso!",
  "This action is mandatory.": "Esta acción es obligatoria.",
  "This field is mandatory": "Este campo es obligatorio",
  "This form is signed": "Este formulario ha sido firmado",
  "This message is marked as urgent": "Este mensaje está marcado como urgente",
  "This recovery email is already in use!": "Este e-mail de recuperação já está em uso!",
  "This request is not valid anymore": "Esta solicitud ya no es válida",
  "This section is used to deal with visible damage to the airplane": "Esta sección se utiliza para tratar los daños visibles del avión. Por favor, documente todos los problemas visibles antes de realizar cualquier servicio",
  "This service has been registered for this flight over 80% of the time.": "Este servicio ha sido registrado para este vuelo más del 80% del tiempo.",
  "time": " tiempo.",
  "Time registration": "Registro de tiempo",
  "Timeline": "Cronología",
  "Timestamp information": "Información de timestamp",
  "Timestamps type": "Tipo de sello de tiempo",
  "to": "a",
  "To get a new one, simply follow these steps:": "Para obter um novo, basta seguir estes passos:",
  "Today": "Hoy",
  "TODAY": "HOY",
  "Tomorrow": "Mañana",
  "Transfer Bags": "Bolsas de Transferência",
  "Truck Driver": "Conductor de camión",
  "Truck driver's signature": "Assinatura do motorista do caminhão",
  "Truck driver's signature:": "Firma del camionero:",
  "Truck Number": "Número de camión",
  "type": "tipo",
  "Type": "Tipo",
  "Unavailable": "No disponible",
  "Unread": "No leído",
  "Until": "Bis",
  "Unverified email": "¡Correo electrónico no verificado!",
  "uppercase": "mayúsculas",
  "Username": "Nombre de usuario",
  "Username or email": "Nome de utilizador ou e-mail",
  "validating": "validando",
  "validation": "validación",
  "Verification Error": "Erro de verificação",
  "Verification Link Expired": "Link de verificação expirado",
  "Verified email": "Correo electrónico verificado",
  verify: {
    "alreadyVerifiedTitle": "¡Correo de recuperación ya verificado!",
    "error1": "Ocurrió un error al intentar verificar tu dirección de correo electrónico.",
    "error2": "Por favor, intenta usar el enlace nuevamente.",
    "error3": "Si el problema continúa, ve a <1>Mi perfil</1> para reenviar un nuevo enlace de verificación.",
    "errorTitle": "Error de verificación",
    "expiredStep1": "Ve a <1>Mi perfil</1> en tu cuenta de Sunrise.",
    "expiredStep2": "Busca la sección de recuperación de cuenta y haz clic en \"Reenviar correo de verificación\".",
    "expiredStepsIntro": "Para obtener uno nuevo, simplemente sigue estos pasos:",
    "expiredTitle": "Enlace de verificación caducado",
    "successDescription": "Ahora puedes usarlo para recuperar el acceso a tu cuenta si olvidas tu contraseña.",
    "successTitle": "¡Correo de recuperación verificado!",
    "verifying": "Verificando..."
  },
  "Verifying...": "Verificando...",
  "View key people": "Ver personas clave",
  "Visibility": "Visibilidad",
  "Visual checks must be performed AFTER GSE removal": "Las verificaciones visuales deben realizarse después de retirada de Equipos",
  "Visual checks must be performed BEFORE GSE positioning": "Las verificaciones visuales deben realizarse antes del posicionamiento de Equipos",
  "Walkaround Arrival Checklist": "Lista de verificación de llegada de caminata",
  "Walkaround Pre-Departure Checklist": "Lista de verificación previa a la partida de caminata",
  "We apologize for the inconvenience.": "Pedimos desculpas pelo transtorno.",
  "We strongly recommend saving it in your smartphone phonebook": "Le recomendamos encarecidamente que lo guarde en la agenda de su smartphone para tener siempre a mano el código APPI. Para guardar el código, ve a tu perfil de Sunrise y escanea el código QR con tu smartphone.",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "Recomendamos fortemente que você o salve na agenda do seu smartphone para que você sempre tenha o código APPI em mãos. Para salvar o código, vá para o seu perfil Sunrise e escaneie o código QR com seu smartphone.",
  "Weather": "Tiempo",
  "Wind": "Viento",
  "Would you like to add it to your current registration?": "¿Te gustaría agregarlo a tu registro actual?",
  "Write comment": "Escribir comentario",
  "write new comment": "escribir un nuevo comentario",
  "Write your comment here, then press the green check mark": "Escriba su comentario aquí y pulse la marca de verificación verde",
  "Year": "Año",
  "Yes": "Sí",
  "Yesterday": "Ayer",
  "You are offline": "Estás desconectado.",
  "You can check your APPI code on Sunrise portal.": "Puede comprobar su código APPI en el portal Sunrise.",
  "You can now use it to regain access to your account if you forget your password.": "Agora você pode usá-lo para recuperar o acesso à sua conta se esquecer sua senha.",
  "You can't remove this temporal item": "No se puede eliminar este elemento temporal",
  "You don't have permission to view clocked times": "No tienes permiso para ver las horas registradas",
  "You don't have permissions to take a photo": "No tienes permisos para hacer una foto",
  "You were signed out automatically": "Se ha cerrado la sesión automáticamente. El token ha caducado. Puede volver a iniciar sesión con sus credenciales",
  "Your password and confirmation password do not match": "Su contraseña y su contraseña de confirmación no coinciden.",
  "Your password has been changed successfully!": "Su contraseña ha sido cambiada con éxito.",
  "Your password has expired. Please compose a new password and log in again.": "Su contraseña ha caducado. Por favor, componga una nueva contraseña y conéctese de nuevo.",
  "Your password must contain at least eight characters": "Su contraseña debe contener al menos ocho caracteres, al menos un número y letras minúsculas y mayúsculas ",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "Sua senha deve conter pelo menos oito caracteres, pelo menos um número e letras minúsculas e maiúsculas.",
  "Your recovery email is already verified!": "Seu e-mail de recuperação já está verificado!",
  "Your session has expired. Please sign in again.": "Su sesión ha expirado. Por favor, inicie sesión de nuevo."
};
